import { set } from "lodash";
import React, { useState, useEffect } from "react";
import { Fragment } from "react";
import { Helmet } from "react-helmet";
import DataTable from "../../../../Common/Components/DataTable";
import Loading from "../../../../Common/Components/Loading";
import { GetQuestion, DeleteData, checkEmpty } from "../Components/Services";

function List() {
  const initialState = {
    loading: true,
    data: null,
  };
  const [state, setstate] = useState(initialState);
  const handler = (pageNumber = 1) => {
    setstate({ ...state, loading: true });
    GetQuestion(pageNumber).then(data => {
      setstate({ ...state, loading: false, data: data });
    });
  };

  const deleteData = data => {
    setstate({ ...state, loading: true });
    DeleteData(data).then(() => {
      GetQuestion().then(result => {
        setstate({ loading: false, data: result });
      });
    });
  };
  useEffect(() => {
    handler();
  }, []);

  return (
    <Fragment>
      <Helmet>
        <title></title>
      </Helmet>

      <Fragment>
        {checkEmpty(state.data) ? (
          <DataTable
            loading={state.loading}
            heads={[
              { title: "لیست سوالات ", key: "question" },
              { title: "لیست پاسخ ها ", key: "answer" },
            ]}
            header="سوالات متداول"
            textEmpty="پرسشی وجود ندارد"
            list={state.data.data}
            data={state.data}
            textbtn="ایجاد سوال جدید"
            function={handler}
            linkbtn="/Admin/QuestionsSestting/Create"
            currentPage={state.data.current_page}
            links={[
              {
                function: selected => {
                  deleteData({ question_id: selected[0] });
                },
                color: "danger",
                size: "col-md-2",
                html: "حذف",
                multi: true,
                main: true,
                type: "edit",
              },
            ]}
          />
        ) : (
          <span>اطلاعات موجود نیست</span>
        )}
      </Fragment>
    </Fragment>
  );
}

export default List;
